import { getEnvVar } from '../utils/getEnvVar';
import { FileInput } from '@deere/fuel-react/FileInput.js';
import { FileList } from '@deere/fuel-react/FileList.js';
import { FileListItem } from '@deere/fuel-react/FileListItem.js';

export function FileUpload({
  setStatusErrorMsg,
  updateContent,
  clearAllMessages
}) {
  const maxSizeInBytes = Number(getEnvVar('VITE_MAX_ATTACH_SIZE_IN_BYTES'));
  const maxSizeMB = Number(getEnvVar('VITE_MAX_ATTACH_SIZE_IN_MB'));
  const blockList = ['exe', 'js', 'com', 'sh', 'dmg', 'pkg', 'app'];

  const guards = [
    {
      isValid: (file) => file.size <= maxSizeInBytes,
      message: `File size larger than ${maxSizeMB}mb not allowed`
    },
    {
      isValid: (file) => {
        const extension = file.name.toLowerCase().split('.').pop();
        return !blockList.includes(extension);
      },
      message:
        'File types: .exe, .js, .com, .sh, .dmg, .pkg, .app are not allowed. Please remove and upload a valid file.'
    }
  ];

  const validateFile = (file) => {
    return guards.reduce((messages, guard) => {
      if (!guard.isValid(file)) {
        return [...messages, guard.message];
      }
      return messages;
    }, []);
  };

  const handleUpdateContent = (files) => {
    const firstFile = files?.[0];
    if (firstFile) {
      const errors = validateFile(firstFile);
      if (errors.length > 0) {
        updateContent([]);
        errors.forEach((msg) => setStatusErrorMsg(msg));
      } else {
        clearAllMessages();
        updateContent([firstFile]);
      }
    } else {
      updateContent([]);
      clearAllMessages();
    }
  };

  return (
    <FileInput
      fullWidth
      multiple={false}
      accept={{ '*': ['*'] }}
      onChange={(event) => {
        handleUpdateContent(Array.from(event.currentTarget.files || []));
      }}
      renderFileList={(fileList) => (
        <FileList>
          {fileList?.map((file) => {
            const errorMessages = validateFile(file);
            return (
              <FileListItem
                errorMessages={errorMessages}
                key={file.name}
                size={file.size}
                text={file.name}
              />
            );
          })}
        </FileList>
      )}
    />
  );
}
